const apiUrl = process.env.REACT_APP_API_LOCAL_URL
const resources = {
    portal: process.env.REACT_APP_PORTAL_SRV
}

function getIdentityId(body, userID){
    if(userID){
        return userID
    }else{
        if('userID' in body){
            return body.userID
        }
    }
    return null
}

console.log(apiUrl)

class LocalAPI {

    get(pathString, resource, userID){
    console.log(`GET ${pathString}`)
 
    const url = `${apiUrl}:${resources[resource]}${pathString}`

    const identityId = getIdentityId({}, userID)
    if(!identityId){
        return Promise.reject(new Error('Identity Id Required for Local Test Server'))
    }

    const headers = new Headers({
        "Content-Type": 'application/json',
        'x-identity-header': identityId
      });

        return fetch(url, {
        method: "GET",
        // mode: 'no-cors',
        headers: headers
        }).then((response) => {
            if(response.status === 200){
            return response.json()
            }
            return response.text()
            .then(textResponse => {
            return Promise.reject(new Error(textResponse))
            })
        })

    }

    put(pathString, body, resource, userID){
        console.log(`PUT ${pathString}`)
        console.log(`PUT ${resources}`)
    
        console.log(`PUT ${resource}`)
        const url = `${apiUrl}:${resources[resource]}${pathString}`
        const identityId = getIdentityId(body, userID)
        if(!identityId){
            return Promise.reject(new Error('Identity Id Required for Local Test Server'))
        }
        console.log(identityId)
        const headers = new Headers({
            "Content-Type": 'application/json',
            'x-identity-header': identityId
          });
    return fetch(url, {
        method: "PUT",
        body: JSON.stringify(body),
        //mode: 'no-cors',
        headers: headers
    }).then((response) => {
        console.log(response)
        if(response.status === 200){
        return response.json()
        }else{
        return Promise.reject(new Error('Error Loading Visit'))
        }
    })
    }

    post(pathString, body, resource, userID){
        console.log(`POST ${pathString}`)
   
        const url = `${apiUrl}:${resources[resource]}${pathString}`
        const identityId = getIdentityId(body, userID)
        if(!identityId){
            return Promise.reject(new Error('Identity Id Required for Local Test Server'))
        }
        const headers = new Headers({
            "Content-Type": 'application/json',
            'x-identity-header': identityId
          });

          console.log(identityId)
          console.log(url)
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
       // mode: 'no-cors',
        headers: headers
    }).then((response) => {
        console.log(response)
        if(response.status === 200){
        return response.json()
        }else{
        return Promise.reject(new Error('Error Loading Visit'))
        }
    })
    }

    patch(pathString, body, resource, userID){
    console.log(`PATCH ${pathString}`)

    const url = `${apiUrl}:${resources[resource]}${pathString}`

    const identityId = getIdentityId(body, userID)
    if(!identityId){
        return Promise.reject(new Error('Identity Id Required for Local Test Server'))
    }

    const headers = new Headers({
        "Content-Type": 'application/json',
        'x-identity-header': identityId
      });

    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        //mode: 'no-cors',
        headers: headers
    }).then((response) => {
        //console.log(response)
        if(response.status === 200){
        return response.json()
        }else{
        return Promise.reject(new Error('Error Loading Visit'))
        }
    })
    }
}

export default LocalAPI


// WEBPACK FOOTER //
// ./src/stores/Local.js